var m = require('mithril');
var formGroup = require('../formGroup');

var component = {};

component.oninit = function oninit (vnode) {
  vnode.state.showPassword = false;
};

component.view = function view (vnode) {
  var inputId = (vnode.attrs.field.id || 'password') + '-input';
  var showPassword = !!vnode.state.showPassword;
  var toggleLabel = showPassword ? 'Hide password' : 'Show password';

  return m(formGroup, [
    m('label', {for: inputId}, vnode.attrs.field.name),
    m('div.flex.items-stretch', [
      m('input.form-control', {
        id: inputId,
        type: showPassword ? 'text' : 'password',
        autocomplete: vnode.attrs.autocomplete || 'off',
        oninput: function(ev){vnode.attrs.prop(ev.target.value)},
        value: vnode.attrs.prop(),
        style: {
          flex: '1 1 auto',
          minWidth: 0
        }
      }),
      m('button.bg-mid-gray.near-white.bn.pointer.f4.flex.items-center.justify-center', {
        type: 'button',
        title: toggleLabel,
        'aria-label': toggleLabel,
        'aria-pressed': showPassword ? 'true' : 'false',
        onclick: function () {
          vnode.state.showPassword = !showPassword;
        },
        onmousedown: function (ev) {
          ev.preventDefault();
        },
        style: {
          width: '2.75em',
          minHeight: '2.5em'
        }
      }, [
        m('i.blue.' + (showPassword ? 'ion-eye-disabled' : 'ion-eye'))
      ])
    ])
  ]);
};

module.exports = component;
